import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";

interface Props {
  video: VideoItem;
  compact?: boolean;
}

export default function VideoCard({ video, compact = false }: Props) {
  return (
    <article className="group bg-background-100 rounded-lg overflow-hidden border border-background-200 hover:-translate-y-1 transition-transform">
      <Link to={`/detail/${video.slug}`} className="block relative aspect-video overflow-hidden">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - ${video.categoryName}吃瓜视频`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <span className="absolute left-2 top-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[11px] font-bold">
          {video.tag}
        </span>
        <span className="absolute right-2 bottom-2 flex items-center gap-1 px-1.5 py-0.5 rounded bg-black/60 text-background-50 text-[11px]">
          <i className="ri-play-mini-fill"></i>
          {video.duration}
        </span>
        {video.hot && (
          <span className="absolute right-2 top-2 flex items-center gap-0.5 px-1.5 py-0.5 rounded bg-accent-500 text-background-50 text-[11px] font-bold">
            <i className="ri-fire-fill"></i>热
          </span>
        )}
      </Link>
      <div className={compact ? "p-3" : "p-4"}>
        <h3 className={`${compact ? "text-sm" : "text-[15px]"} font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors`}>
          <Link to={`/detail/${video.slug}`}>{video.title}</Link>
        </h3>
        {!compact && (
          <p className="mt-2 text-xs text-foreground-600 line-clamp-2">{video.summary}</p>
        )}
        <div className="mt-2.5 flex items-center justify-between text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {video.date}
          </span>
        </div>
      </div>
    </article>
  );
}